module.exports = __webpack_public_path__ + "img/img3.72845e6a.jpg";